import { render, staticRenderFns } from "./ActivityCommentEntry.vue?vue&type=template&id=5e783bec&scoped=true"
import script from "./ActivityCommentEntry.vue?vue&type=script&lang=ts"
export * from "./ActivityCommentEntry.vue?vue&type=script&lang=ts"
import style0 from "./ActivityCommentEntry.vue?vue&type=style&index=0&id=5e783bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e783bec",
  null
  
)

export default component.exports